module.exports = __webpack_public_path__ + "static/img/animals6.1.521c070c.png";